import { FaSearch, FaTimes } from "react-icons/fa";

import "./index.scss";

const SearchInput = ({
  value,
  onChange,
  onClear,
  onSearch,
  placeholder,
  maxLength,
  buttonText,
}) => {
  return (
    <div className="search-input">
      <div className="search-input__icon">
        <FaSearch />
      </div>
      <input
        type="text"
        value={value}
        maxLength={maxLength}
        className="search-input__field"
        onChange={onChange}
        placeholder={placeholder}
      />
      {value && (
        <div className="search-input__clear" onClick={onClear}>
          <FaTimes />
        </div>
      )}
      <button className="search-input__btn" onClick={onSearch}>
        {buttonText}
      </button>
    </div>
  );
};

export default SearchInput;
